import { Component, OnInit, Input } from '@angular/core';
import { SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-product-banner-carousel',
  templateUrl: './product-banner-carousel.component.html',
  styleUrls: ['./product-banner-carousel.component.scss']
})
export class ProductBannerCarouselComponent implements OnInit {
  @Input('slides') slides: Array<any> = [];
  public config: SwiperConfigInterface = {};
  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true
  };
  constructor(
   
  ) { }
  ngOnInit() { 
    
  }
  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: 5,
      keyboard: true,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: "slide"
    }
  }
}

